var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    { staticClass: "main-header navbar navbar-expand navbar-dark elevation-2" },
    [
      _c("ul", { staticClass: "navbar-nav" }, [
        _c("li", { staticClass: "nav-item" }, [
          _c(
            "a",
            {
              staticClass: "nav-link",
              attrs: { "data-widget": "pushmenu", href: "#", role: "button" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.onClick.apply(null, arguments)
                },
              },
            },
            [_c("i", { staticClass: "fas fa-bars" })]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm.windowWidth < 992 && _vm.sidebarOverlay
        ? _c("div", {
            attrs: { id: "sidebar-overlay" },
            on: { click: _vm.onClick },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("ul", { staticClass: "navbar-nav ml-auto" }, [
        _c("li", { staticClass: "nav-item" }, [
          _c(
            "a",
            {
              staticClass: "nav-link pointer",
              attrs: { title: "Profil " + _vm.loggedInUser?.name },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.goToProfile.apply(null, arguments)
                },
              },
            },
            [
              _c("i", { staticClass: "fa fa-user-circle" }),
              _vm._v(" Hi, " + _vm._s(_vm.loggedInUser?.name) + "\n      "),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "nav-item" }, [
          _c(
            "a",
            {
              staticClass: "nav-link",
              attrs: { href: "#", title: "Keluar" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.logout.apply(null, arguments)
                },
              },
            },
            [
              _c("i", { staticClass: "fa fa-sign-out-alt" }),
              _vm._v(" Keluar\n      "),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "collapse navbar-collapse",
        attrs: { id: "navbarToggler" },
      },
      [_c("ul", { staticClass: "navbar-nav" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }